import { TranslationModel } from '@/core/domain/translation/models/translation.model';
import { createAction, props } from '@ngrx/store';

export const loadAction = createAction(
    '[Translation] load',
    props<{ value: TranslationModel }>(),
);
